import {Component, effect, inject, input, signal, untracked, ChangeDetectionStrategy} from '@angular/core';
import {ApiService} from '../_services/api.service';
import {lastValueFrom} from 'rxjs';

export enum PdfPreviewState {
  loading,
  error,
  loaded
}

@Component({
    selector: 'app-form-preview',
    templateUrl: './form-preview.component.html',
    styleUrl: './form-preview.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormPreviewComponent {
  protected readonly pdfViewerCustomCss = `
    #outerContainer {
      --toolbar-height: 0px !important;
    }

    #toolbarContainer {
      display: none !important;
      height: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      box-shadow: none !important;
    }

    #viewerContainer {
      inset: 0 !important;
    }

    #mainContainer {
      min-width: 0 !important;
    }

    #outerContainer,
    #viewerContainer {
      min-width: 0 !important;
    }

    .annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,
    .annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after,
    .annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before {
      background-color: #111 !important;
    }
  `;
  pdfPreviewBlob = signal<Blob | null>(null);
  pdfPreviewUrl = signal<string | null>(null);
  pdfFillJson = input.required<string>();
  pdfPreviewState = signal(PdfPreviewState.loading);
  private apiService = inject(ApiService);
  protected readonly PdfPreviewState = PdfPreviewState;

  constructor() {
    effect(() => {
      const jsonValue = this.pdfFillJson();
      if (!jsonValue) {
        return;
      }

      untracked(() => {
        this.handlePdfJsonChange(jsonValue);
      });
    });
  }

  private async handlePdfJsonChange(json: string): Promise<void> {
    this.pdfPreviewState.set(PdfPreviewState.loading);
    try {
      const rawBlob = await lastValueFrom(this.apiService.getRenderedPdf(json));
      const blob = new Blob([rawBlob], {type: 'application/pdf'});
      this.pdfPreviewUrl.set(URL.createObjectURL(blob));
      this.pdfPreviewBlob.set(blob);
      this.pdfPreviewState.set(PdfPreviewState.loaded);
      console.log('PDF preview URL:', this.pdfPreviewUrl());
    } catch (error) {
      console.error(error);
      this.pdfPreviewState.set(PdfPreviewState.error);
    }
  }

  protected onClickRetry(): void {
    this.handlePdfJsonChange(this.pdfFillJson()).then();
  }
}
